import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Form} from 'react-final-form';
import {TextField, Checkbox, SaveButton} from '../../common';
import {MAX_NAME_LEN} from '../../../configs/constants';

const NewGameModal = (props) => {
  const {onFormSubmit, gameConfig: {playerLimit, isAudienceAllowed, isPublished}} = props;
  const cellClassNames = classNames({
    cell: true,
    'text-right': true,
    cell_bordered: isAudienceAllowed,
  });
  const renderErrorMessage = () => (
    <div className="modal__content text-center">
      You cannot create a game because this application has not been published yet.
    </div>
  );
  const renderForm = () => (
    <Form
      onSubmit={onFormSubmit}
      validateOnBlur={false}
      render={({handleSubmit, pristine, invalid}) => (
        <form action="#" className="form" onSubmit={handleSubmit}>
          <TextField
            label="Game Name"
            labelSize="m"
            placeholder="Enter name "
            name="name"
            type="text"
            maxLength={MAX_NAME_LEN}
            required
          />
          <div className="form__row form__row_gap_m row modal__new-game_txt">
            {isAudienceAllowed && <Checkbox label="Allow audience members" name="isAudienceAllowed" rowGap="none"/>}
            <div className={cellClassNames}>
              This game will have a maximum of {playerLimit} players.
            </div>
          </div>
          <div className="row row_center">
            <SaveButton
              size="xl"
              type="submit"
              text="Create game"
              disabled={pristine || invalid}
            />
          </div>
        </form>
      )}
    />
  );

  return isPublished ? renderForm() : renderErrorMessage();
};

NewGameModal.propTypes = {
  onFormSubmit: PropTypes.func.isRequired,
  gameConfig: PropTypes.shape({
    playerLimit: PropTypes.number.isRequired,
    isAudienceAllowed: PropTypes.bool,
    isPublished: PropTypes.bool,
  }).isRequired,
};

export default NewGameModal;
